<template>
  <div>
    <!-- <router-link v-if="isFrisysAdmin()" to="/competition/add">Legg til nytt Stevne</router-link> -->
    <!-- <router-link v-if="RoleService.checkRole('frisys_admin')" to="/competition/add">Legg til nytt Stevne</router-link> -->
    <router-link v-if="checkRole('frisys_admin')" to="/competition/add">Legg til nytt Stevne</router-link>
    <CompetitionsList></CompetitionsList>
  </div>
</template>

<script>
import CompetitionsList from '../components/CompetitionsList.vue';

export default {
  name: 'Competitions',
  components: {
    CompetitionsList
  }
};
</script>